/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react';
import DateInput from '../../global/DateInput';
import countryList from 'react-select-country-list';
// import countryCodes from 'country-codes-list';
// import { DatePickerProps } from 'antd';
import Dropdown from '../../../common/dropdown/Dropdown';
import { TInfo, TStep4Info } from '../../../types';
import Button from '../../global/Button';
import plusIcon from '../../../assets/images/tbh/dashboardImages/plus.svg';
import { useVerifyBvnMutation } from '../../../features/businessRegistration/businessRegistrationSlice';
import { toast } from 'react-toastify';
import { validateEmail } from '../../../lib/validateEmail';
import Button2 from '../../global/Button2';
import { countryCodes } from '../../../utils/countryCodes';
import Tippy from '@tippy.js/react';
import { wqkgx } from '../../../config/keys';
import CryptoJS from 'crypto-js';
import { encryptData } from '../../../utils/encryptJson';
import { logUserOut } from '../../../utils/logUserOut';
import { getFromLocalStorage } from '../../../utils/setRegInfoInLocalStorage';

type BusinessOwnerFormProps = {
  info: TStep4Info;
  setInfo: React.Dispatch<React.SetStateAction<TStep4Info[]>>;
  setInvalidState: React.Dispatch<React.SetStateAction<boolean>>;
  partners: TStep4Info[];
  index: number;
  setShowAddPartnersForm: React.Dispatch<React.SetStateAction<boolean>>;
  setShowingPartner: React.Dispatch<React.SetStateAction<boolean>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  showAddPartnersForm: boolean;
  invalidOwnerState: boolean;
};

const BusinessPartnerFilledForm = ({
  info,
  setInfo,
  setInvalidState,
  partners,
  index,
  setShowingPartner,
  setStep,
  showAddPartnersForm,
  setShowAddPartnersForm,
  invalidOwnerState,
}: //   setShowAddPartnersForm,
BusinessOwnerFormProps) => {
  const codes: any = countryCodes;
  const countries = useMemo(() => countryList().getData(), []);
  const [disabled, setDisabled] = useState<boolean>(false);
  const token = localStorage.getItem('login-token');
  const [showTippy, setShowTippy] = useState(false);

  const isfirstNameValid = info.firstName?.length > 0;
  const islastNameValid = info.lastName?.length > 0;
  const isBusinessEmailValid = validateEmail(info.businessEmail);
  const isOccupationValid = info.occupation?.length > 0;
  const isBvnValid = info.bvn && info.bvn?.length === 11;
  const isBvnPhoneValid = info.bvnPhone && info.bvnPhone?.length >= 10;
  const isNationalityValid = info.nationality?.length > 0;
  const isGenderValid = info.gender?.length > 0;
  const isIdentityTypeValid = info.identityType?.length > 0;
  const isIdentityNumberValid = info.identityNumber?.length === 11;
  const isBirthDateValid = info.birthDate ? true : false;

  const [verify, { isLoading, isSuccess }] = useVerifyBvnMutation();

  const validateInputsResult = useMemo(() => {
    return (
      isfirstNameValid &&
      islastNameValid &&
      isBusinessEmailValid &&
      isOccupationValid &&
      // isBvnValid &&
      isBvnPhoneValid &&
      isNationalityValid &&
      isGenderValid &&
      isIdentityTypeValid &&
      isIdentityNumberValid &&
      isBirthDateValid
    );
  }, [
    isBirthDateValid,
    isBusinessEmailValid,
    isBvnPhoneValid,
    // isBvnValid,
    // isFormerNameValid,
    isGenderValid,
    isIdentityNumberValid,
    isIdentityTypeValid,
    isNationalityValid,
    isOccupationValid,
    // isOtherNameValid,
    isfirstNameValid,
    islastNameValid,
  ]);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult, isSuccess]);

  useEffect(() => {
    setShowingPartner(true);
  }, [setShowingPartner]);

  // useEffect(() => {
  //   if (info.bvn) {
  //     if (info?.bvn?.length === 11 && info?.bvnPhone?.length === 11) {
  //       verifyBVN({
  //         bvn: info.bvn,
  //         bvnPhone: info.bvnPhone,
  //       });
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [info.bvn, info.bvnPhone]);

  // const verifyBVN = async (data: any) => {
  //   try {
  //     const response = await verify({
  //       token,
  //       body: encryptData({
  //         bvn: CryptoJS.AES.encrypt(data.bvn, wqkgx).toString(),
  //         phoneNumber: data.bvnPhone.replace(/[+]/g, ''),
  //       }),
  //     }).unwrap();
  //     toast.success(response.message);
  //   } catch (err: any) {
  //     logUserOut(err?.status);
  //     toast.error(err?.data?.message);
  //   }
  // };

  // const form1 = localStorage.getItem('form1');
  const form1 = getFromLocalStorage('form1');
  const step1Info: TInfo = form1 && JSON.parse(form1);
  const countryCode = countries.find((country) => country.label === info.nationality)?.value;

  const submitFn2 = () => {
    partners.length < Number(step1Info.noOfPartners?.replace('partner ', ''))
      ? setShowAddPartnersForm(true)
      : setStep((currPage: any) => currPage + 1);
  };
  return (
    <form className='w-full'>
      <div className='w-full flex justify-center'>
        <div className='w-[100%]'>
          <div className='personal-form'>
            <div className='mb-[27px]'>
              <label className='flex relative text-[#212121] '>
                <div className='flex flex-row'>
                  First name
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isfirstNameValid && (
                  <div className='text-xs text-[red] ml-2 flex items-center'>
                    Invalid first name
                  </div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.firstName ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, firstName: e.target.value.replace(/[0-9]/g, '') };
                    }

                    return partner_;
                  });

                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setInfo(newState);
                  // }
                }}
              />
            </div>
            <div className='mb-[27px]'>
              {/* <FormInput
                  label='Last name'
                  id='Last name'
                  name='lastName'
                  type='text'
                  rules={['required']}
                /> */}

              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Last name
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!islastNameValid && (
                  <div className='text-xs text-[red] ml-2 flex items-center'>Invalid last name</div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.lastName ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, lastName: e.target.value.replace(/[0-9]/g, '') };
                    }

                    return partner_;
                  });

                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setInfo(newState);
                  // }
                }}
              />
            </div>
            <div className='mb-[27px]'>
              {/* <FormInput
                  label='Other names'
                  id='Other names'
                  name='otherName'
                  type='text'
                  rules={['required']}
                /> */}

              <label className='flex items-center ml-2 relative text-[#212121] '>
                Other names
                {/* {!isOtherNameValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid other names</div>
                )} */}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.otherName ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, otherName: e.target.value.replace(/[0-9]/g, '') };
                    }

                    return partner_;
                  });

                  setInfo(newState);
                }}
              />
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>Former name</label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.formername ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, formername: e.target.value.replace(/[0-9]/g, '') };
                    }

                    return partner_;
                  });

                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setInfo(newState);
                  // }
                }}
              />
              {/* /> */}
            </div>
            <div className='w-full text-xs mb-[27px] '>
              {/* <Controller
                  name='nationality'
                  control={control}
                  rules={{
                    required: 'nationality',
                  }}
                  render={({ field: { onChange, value } }) => ( */}
              <Dropdown
                className='border rounded-[4px] !h-[52px] '
                label='Nationality'
                required
                placeholder={info.nationality ?? ''}
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={countries.map((country) => {
                  return {
                    value: country.label,
                    label: country.label,
                    // name: country.value,
                  };
                })}
                width='100%'
                setSelectedOption={
                  //     (e: {value: string, label: string}) => {
                  //     setInfo(prev => ({...prev, nationality: e.value}));
                  //   }
                  (e: { value: string; label: string }) => {
                    const newState = partners.map((partner_) => {
                      if (partner_.identityNumber === info.identityNumber) {
                        return { ...partner_, nationality: e.value };
                      }

                      return partner_;
                    });

                    setInfo(newState);
                  }
                }
              />
              {/* )} */}
              {/* /> */}
            </div>
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                className='border rounded-[4px] !h-[52px] '
                label='Gender'
                required
                placeholder={info.gender ?? ''}
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={[
                  { value: 'Male', label: 'Male' },
                  { value: 'Female', label: 'Female' },
                ]}
                width='100%'
                setSelectedOption={(e: { value: string; label: string }) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, gender: e.value };
                    }

                    return partner_;
                  });

                  setInfo(newState);
                }}
              />
              {/* )}
                /> */}
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Business email address
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isBusinessEmailValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid business email</div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.businessEmail ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, businessEmail: e.target.value?.toLowerCase() };
                    }

                    return partner_;
                  });

                  setInfo(newState);
                }}
              />
            </div>
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                className='border rounded-[4px] !h-[52px] '
                label='Identity Type'
                subLabel='The NIN ID card is the only valid ID card for this registration'
                placeholder={info.identityType ?? ''}
                required
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={[
                  { value: 'National Identity Card', label: 'National Identity Card' },
                  // { value: "Voter's Card", label: "Voter's Card" },
                  // { value: 'Driver License', label: 'Driver License' },
                ]}
                width='100%'
                setSelectedOption={(e: { value: string; label: string }) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, identityType: e.value };
                    }

                    return partner_;
                  });

                  setInfo(newState);
                }}
              />
              {/* )}
                /> */}
            </div>
            <div className='mb-[27px]'>
              <label className='flex flex-row relative text-[#212121] justify-between'>
                <div className='flex flex-row'>
                  Identity number
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {info?.identityNumber?.length > 0 && info?.identityNumber?.length !== 11 && (
                  <span className='text-[red]'>must be 11 digits</span>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.identityNumber ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, identityNumber: e.target.value };
                    }

                    return partner_;
                  });

                  setInfo(newState);
                }}
                maxLength={11}
              />
            </div>
            <div className='mb-[27px]'>
              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Occupation
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isOccupationValid && (
                  <div className='text-xs text-[red] ml-2'>Invalid occupation</div>
                )}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.occupation ?? ''}
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, occupation: e.target.value.replace(/[0-9]/g, '') };
                    }

                    return partner_;
                  });

                  // const re = /^[A-Za-z]+$/;
                  // if (e.target.value === '' || re.test(e.target.value)) {
                  setInfo(newState);
                  // }
                }}

                //   onChange={(e) => {
                //     const re = /^[A-Za-z]+$/;
                //     if (e.target.value === '' || re.test(e.target.value)) {
                //       setInfo(prev => ({...prev, occupation: e.target.value}))
                //     };
                //   }}
              />
            </div>
          </div>
          <div className='bvn-form'>
            <div className='bvn-header mt-[40px] '>
              <h3 className='font-poppins font-bold text-base text-green'>Provide BVN Details</h3>
              <p className='text-[13px] font-poppins font-normal '>
                It will help us to create a current account for your business
              </p>
            </div>
            {/* <div className='my-[27px]'>

              <label className='flex items-center ml-2 relative text-[#212121] '>
                <div className='flex flex-row'>
                  Enter Bank Verification Number (BVN)
                  <span className='text-[red] ml-2'>*</span>
                </div>
                {!isBvnValid && <div className='text-xs text-[red] ml-2'>Invalid bvn</div>}
              </label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                value={info.bvn ?? ''}
                readOnly
                onChange={(e) => {
                  const newState = partners.map((partner_) => {
                    if (partner_.identityNumber === info.identityNumber) {
                      return { ...partner_, bvn: e.target.value };
                    }

                    return partner_;
                  });

                  const re = /^[0-9\b]+$/;
                  if (e.target.value === '' || re.test(e.target.value)) {
                    setInfo(newState);
                  }
                }}
              />
            </div> */}
            <Tippy
              visible={showTippy}
              className='bg-[wheat] text-xs text-[black] w-[280px]'
              arrow={false}
              content={`Enter number with 0 at the beginning e.g 0816*******`}
            >
              <div className='my-[27px]'>
                <label className='flex items-center ml-2 relative text-[#212121] '>
                  <div className='flex flex-col'>
                    <div className='flex flex-row'>
                      Phone Number
                      <span className='text-[red] ml-2'>*</span>
                    </div>
                    <span className='text-[10px] text-[grey]'>
                      CAC only accepts Nigerian numbers
                    </span>
                  </div>
                  {!isBvnPhoneValid && (
                    <div className='text-xs text-[red] ml-2'>Invalid phone number</div>
                  )}
                </label>
                <div className='flex'>
                  <div className='w-[62px] border h-[52px] border-[#F8B400] px-[15px] rounded-[4px]   flex justify-center items-center bg-white'>
                    {countryCode ? codes[countryCode] : `+234`}
                  </div>
                  <input
                    className='w-full h-[52px] px-[10px] md:px-[16px] border-[1px] border-[#B8C9C9] rounded-[4px] focus:border-[#F8B400] outline-none '
                    value={info.bvnPhone ?? ''}
                    readOnly
                    onChange={(e) => {
                      const newState = partners.map((partner_) => {
                        if (partner_.identityNumber === info.identityNumber) {
                          return { ...partner_, bvnPhone: e.target.value };
                        }

                        return partner_;
                      });

                      const re = /^[0-9\b]+$/;
                      if (e.target.value === '' || re.test(e.target.value)) {
                        setInfo(newState);
                      }

                      setShowTippy(true);
                    }}
                  />
                </div>
              </div>
            </Tippy>
          </div>

          {isLoading && (
            <div className='text-xs'>Please wait while we verify the bvn details...</div>
          )}

          <DateInput
            className='!h-[52px]'
            placeholderText='Enter your birth date'
            value={info.birthDate}
            req
            disable={!isSuccess}
            onChange={(e: any) => {
              const newState = partners.map((partner_) => {
                if (partner_.identityNumber === info.identityNumber) {
                  return { ...partner_, birthDate: e._d };
                }

                return partner_;
              });
              setInfo(newState);
            }}
          />

          {!showAddPartnersForm && index === partners.length - 1 && (
            <div className='flex justify-center flex-col md:w-full  mx-auto'>
              <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
                <Button
                  className='px-5 !py-[10px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-[6px] !h-[40px]'
                  size='sm'
                  underline={false}
                  theme='secondary'
                  onClick={() => {
                    setStep((currPage: any) => currPage - 1);
                  }}
                >
                  PREVIOUS
                </Button>
                <Button2
                  // type='submit'
                  size='sm'
                  className={
                    partners.length < Number(step1Info.noOfPartners?.replace('partner ', ''))
                      ? '!bg-[#76839624] font-bold text-[10px] !text-green '
                      : 'px-3 py-[10px] text-[11px] inline-block rounded-[6px] !h-[40px]'
                  }
                  // icon={plusIcon}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowAddPartnersForm(true);
                    submitFn2();
                    // setShowAddBranchForm && setShowAddBranchForm(true)
                  }}
                  disabled={disabled || invalidOwnerState}
                >
                  {partners.length < Number(step1Info.noOfPartners?.replace('partner ', ''))
                    ? `Add new branch`
                    : 'SAVE AND CONTINUE'}
                </Button2>
              </div>
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default BusinessPartnerFilledForm;
